import axios from 'axios';
import { AnyAction } from 'redux';
import { delay, put, retry, select } from 'redux-saga/effects';
import { RESET_STATE } from './Commons';

export const URL_PDF = '/pdf';
export const FETCH_PDF = 'SUCCESS/FETCH_PDF';
export const SET_PDF = 'SUCCESS/SET_PDF';
export const STOP_FETCHING = 'SUCCESS/STOP_FETCHING';
export const STOP_DOWNLOAD = 'SUCCESS/STOP_DOWNLOAD';

export const fetchPdf = (payload: number) => ({
  payload,
  type: FETCH_PDF,
});

export const setPdf = (payload: string) => ({
  payload,
  type: SET_PDF,
});

export const stopFetching = () => ({
  type: STOP_FETCHING,
});

export const stopDownload = () => ({
  type: STOP_DOWNLOAD,
});

const initialState = {
  enableDownload: true,
  fetching: true,
  pdf: '',
};

export default function successReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case SET_PDF:
      return {
        ...state,
        fetching: false,
        pdf: action.payload,
      };
    case STOP_FETCHING:
      return {
        ...state,
        fetching: false,
      };
    case STOP_DOWNLOAD:
      return {
        ...state,
        enableDownload: false,
        fetching: false,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function* doFetchPdf({ payload }: AnyAction) {
  try {
    yield delay(30000);
    const {
      Quote: { uuid },
    } = yield select();

    const config = {
      headers: {
        transactionId: uuid,
      },
    };

    const {
      data: { url },
    } = yield retry(3, 30000, axios.get, `${URL_PDF}/${payload}`, config);
    yield put(setPdf(url));
    yield put(stopFetching());
  } catch (error) {
    yield put(stopDownload());
  }
}
